// Comparação de texto ignorando maiúsculas e acentos ("jose" encontra "JOSÉ").
export const semAcento = (s) =>
  String(s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

// Verdadeiro se `texto` contém `termo`, sem diferenciar acento/caixa. Texto nulo nunca casa.
export const contem = (texto, termo) =>
  texto != null && semAcento(texto).includes(semAcento(termo))
